//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import {
  RequestError,
  gatewayFetch,
  gatewayNoJWTFetch,
} from '@utils/sessionFetch';

import AuthType from './models/AuthType';

function gatewayAuthFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<Response> {
  return gatewayNoJWTFetch('web_gateway', `/api/v1/auth${endpoint}`, init);
}

function gatewayBvUserFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<Response> {
  return gatewayFetch('web_gateway', `/api/v1/portal-users${endpoint}`, init);
}

/**
 * Get the appropriate authentication scheme for a given email address.
 * Responses will be "google_sso", "user_password", or a custom identifier for a SAML IdP.
 *
 * @param email User's email address
 * @returns AuthType of the authentication scheme to use, or null if the user does not exist.
 */
export async function getUserAuthTypeByEmail(
  email: string,
): Promise<AuthType | null> {
  try {
    const res = await gatewayAuthFetch(
      `/auth-type?email=${encodeURIComponent(email)}`,
      { method: 'GET' },
    );
    const data: {
      authType: AuthType;
    } = await res.json();

    return data.authType;
  } catch (e) {
    if (e instanceof RequestError && e.statusCode === 404) {
      // 404 indicates that the user does not exist. Return this as null to the user.
      return null;
    }
    throw e;
  }
}

export async function getUserGuids(emails: Array<string>): Promise<any> {
  const res = await gatewayBvUserFetch(`/guids`, {
    method: 'POST',
    body: JSON.stringify({ emails }),
  });

  return await res.json();
}
